import { Sun, Moon } from 'lucide-react';
import { useThemeStore } from '../store/theme';
import { useT } from '../i18n';

// ANX-084: переключатель свет/тьма. Иконка отражает текущую тему; подсказка —
// действие (на что переключит).
export function ThemeToggle({ className }: { className?: string }) {
  const theme = useThemeStore((s) => s.theme);
  const toggle = useThemeStore((s) => s.toggle);
  const t = useT();
  const isDark = theme === 'dark';
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={t('theme.toggle')}
      aria-pressed={isDark}
      title={isDark ? t('theme.light') : t('theme.dark')}
      className={
        className ??
        'inline-flex h-8 w-8 items-center justify-center rounded-md border border-slate-200 bg-white text-slate-500 hover:bg-slate-100 hover:text-slate-900'
      }
    >
      {isDark ? <Moon size={16} aria-hidden="true" /> : <Sun size={16} aria-hidden="true" />}
    </button>
  );
}
